import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getCommunications, deleteDomain } from "../../api/communications";

export default function CommissionsList({ onEdit }) {
  const [commissions, setCommissions] = useState([]);

  const loadCommissions = async (url) => {
    const data = await getCommunications(url);
    setCommissions(data.items);
  };

  useEffect(() => {
    loadCommissions();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("Supprimer cette commission ?")) {
      await deleteDomain(id);
      loadCommissions();
    }
  };

  return (
      <div className="admin-page">
        <div className="admin-page-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h2 style={{ margin: 0 }}>Gestion des collèges</h2>
          <button className="fr-btn">+ Créer</button>
        </div>

        <p className="admin-page-count">
          {commissions.length} collège{commissions.length > 1 ? "s" : ""}
        </p>

        <div className="table-responsive">
          <table className="table table-vcenter" style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
            <tr style={{ borderBottom: "1px solid #e2e8f0" }}>
              <th className="admin-table-th">Collège</th>
              <th className="admin-table-th">Code</th>
              <th className="admin-table-th">Fiches associées</th>
              <th className="admin-table-th">Domaines associés</th>
              <th className="admin-table-th"></th>
            </tr>
            </thead>

            <tbody>
            {commissions.map((d) => (
                <tr key={d.comId} className="admin-table-row">
                  <td className="admin-table-td">{d.comLib}</td>
                  <td className="admin-table-td">{d.comCode}</td>
                  <td className="admin-table-td">{d.NB_FICHES ?? "—"}</td>
                  <td className="admin-table-td">
                    {(d.domaines || []).length} —{" "}
                    <Link to={`/commissions/${d.comId}/domaines`} className="admin-link">
                      voir les domaines
                    </Link>
                  </td>
                  <td className="admin-table-td" style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                    <button className="fr-btn--secondary" onClick={() => onEdit(d)} style={{ marginRight: 8 }}>
                      Modifier
                    </button>
                    {d.supprimable > 0 && (
                        <button
                            className="fr-btn--danger"
                            onClick={() => handleDelete(d.COM_CODE)}
                            title="Supprimer"
                            style={{ border: "none", background: "transparent" }}
                        >
                          🗑️
                        </button>
                    )}
                  </td>
                </tr>
            ))}
            </tbody>
          </table>
        </div>
      </div>
  );
}
